<div class="cost-performance-tab-container">
  <!-- KPI Cards -->
  <div class="kpi-cards">
    <div class="kpi-card">
      <p class="kpi-label">Planned AFE Cost</p>
      <span class="kpi-value">
        {{ isMultiWellMode ? fmtK(multiWellTotalPlannedAFE) : fmtK(COST_DATA.plannedAFE) }}
      </span>
      <p class="kpi-description">{{ isMultiWellMode ? 'Total of All Selected Wells' : 'Original Approved AFE' }}</p>
    </div>
    <div class="kpi-card">
      <p class="kpi-label">Actual Field Cost Estimate</p>
      <span class="kpi-value">
        {{ isMultiWellMode ? fmtK(multiWellTotalActualCost) : fmtK(COST_DATA.breakdown[1].actual) }}
      </span>
      <p class="kpi-description">{{ isMultiWellMode ? 'Total of All Selected Wells' : 'Total Field Cost Estimate' }}</p>
    </div>
    <div class="kpi-card">
      <p class="kpi-label">Variance</p>
      <span class="kpi-value"
        [ngClass]="(isMultiWellMode ? multiWellTotalVariance : COST_DATA.variance) >= 0 ? 'favorable' : 'unfavorable'">
        {{ (isMultiWellMode ? multiWellTotalVariance : COST_DATA.variance) < 0 ? '+' : ((isMultiWellMode ? multiWellTotalVariance : COST_DATA.variance) > 0 ? '-' : '') }}{{ fmtK(abs(isMultiWellMode ? multiWellTotalVariance : COST_DATA.variance)) }}
      </span>
      <p class="kpi-description">
        {{ (isMultiWellMode ? multiWellTotalVariance : COST_DATA.variance) >= 0 ? 'Under AFE (favorable)' : 'Over AFE (unfavorable)' }}
      </p>
      <p class="kpi-percent"
        [ngClass]="(isMultiWellMode ? multiWellTotalVariance : COST_DATA.variance) >= 0 ? 'favorable' : 'unfavorable'">
        {{ variancePct() !== 0 ? (variancePct() < 0 ? '▼' : '▲') : '' }}
        {{ variancePct() > 0 ? '+' : '' }}{{ variancePct().toFixed(2) }}%
      </p>
    </div>
  </div>

  <!-- Per-Well Cost Summary Table (Multi-Well Mode Only) -->
  <div class="data-table" *ngIf="isMultiWellMode">
    <div class="table-header">
      <h3 class="table-title">Well-wise Cost & Duration Summary</h3>
      <p class="table-description">Planned AFE Cost | Actual Field Cost | Variance | Variance % | Duration</p>
    </div>
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>Well Name</th>
            <th>Planned AFE Cost ($K)</th>
            <th>Actual Field Cost ($K)</th>
            <th>Variance ($K)</th>
            <th>Variance (%)</th>
            <th>Planned Dur (hours)</th>
            <th>Actual Dur (hours)</th>
            <th>Dur Variance (hours)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let w of multiWellCostSummary">
            <td style="font-weight: bold;">{{ w.wellName }}</td>
            <td>{{ w.plannedAFE > 0 ? fmtK(w.plannedAFE) : '—' }}</td>
            <td>{{ w.actualCost > 0 ? fmtK(w.actualCost) : '—' }}</td>
            <td [ngClass]="w.variance > 0 ? 'deviation-favorable' : w.variance < 0 ? 'deviation-unfavorable' : 'deviation-neutral'" style="font-weight: bold;">
              {{ w.variance !== 0 ? (w.variance > 0 ? '▼' : '▲') : '' }}
              {{ w.variance < 0 ? '+' : (w.variance > 0 ? '-' : '') }}{{ fmtK(abs(w.variance)) }}
            </td>
            <td [ngClass]="w.variancePct > 0 ? 'deviation-favorable' : w.variancePct < 0 ? 'deviation-unfavorable' : 'deviation-neutral'" style="font-weight: bold;">
              {{ w.variancePct !== 0 ? (w.variancePct > 0 ? '▼' : '▲') : '' }}
              {{ w.variancePct < 0 ? '+' : (w.variancePct > 0 ? '-' : '') }}{{ abs(w.variancePct).toFixed(2) }}%
            </td>
            <td>{{ w.plannedDuration > 0 ? w.plannedDuration.toFixed(2) : '—' }}</td>
            <td>{{ w.actualDuration > 0 ? w.actualDuration.toFixed(2) : '—' }}</td>
            <td [ngClass]="w.durationVariance < 0 ? 'deviation-favorable' : w.durationVariance > 0 ? 'deviation-unfavorable' : 'deviation-neutral'" style="font-weight: bold;">
              {{ w.durationVariance !== 0 ? (w.durationVariance < 0 ? '▼' : '▲') : '' }}
              {{ w.durationVariance > 0 ? '+' : '' }}{{ w.durationVariance !== 0 ? w.durationVariance.toFixed(2) : '0' }}
            </td>
          </tr>
          <tr *ngIf="!multiWellCostSummary || multiWellCostSummary.length === 0">
            <td colspan="8" style="text-align:center;color:#9ca3af;">No cost data available</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Phase-wise Duration Table -->
  <div class="data-table">
    <div class="table-header">
      <h3 class="table-title">Phase-wise Duration</h3>
      <p class="table-description">P&amp;A phase breakdown — duration, activity and equipment</p>
    </div>
    <div class="table-scroll">
      <table>
        <thead>
          <tr *ngIf="isMultiWellMode">
            <th>Well Name</th>
            <th>Well Phase</th>
            <th>Sub Phase</th>
            <th>Planned Dur (hrs)</th>
            <th>Total Dur (hrs)</th>
            <th>Dur Deviation (hrs)</th>
          </tr>
          <tr *ngIf="!isMultiWellMode">
            <th>Well Phase</th>
            <th>Sub Phase</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Planned Dur (hrs)</th>
            <th>Total Dur (hrs)</th>
            <th>Dur Deviation (hrs)</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="isMultiWellMode">
            <tr *ngFor="let w of multiWellPhaseGrouped">
              <td>{{ w.wellName }}</td>
              <td style="color:#0B2D71;font-weight: 700;">{{ w.primaryJobType || '—' }}</td>
              <td>{{ w.subPhase || '—' }}</td>
              <td>{{ w.plannedDuration || '—' }}</td>
              <td>{{ w.totalDuration || '—' }}</td>
              <td [ngClass]="w.durationDeviation < 0 ? 'deviation-favorable' : w.durationDeviation > 0 ? 'deviation-unfavorable' : 'deviation-neutral'" style="font-weight: bold;">
                {{ w.durationDeviation !== 0 ? (w.durationDeviation < 0 ? '▼' : '▲') : '' }}
                {{ w.durationDeviation > 0 ? '+' : '' }}{{ (w.durationDeviation !== 0 ? w.durationDeviation : 0).toFixed(2) }}
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!isMultiWellMode">
            <tr *ngFor="let r of PHASE_WISE">
              <td style="color:#0B2D71;font-weight: 700;">{{ r.WellPhase }}</td>
              <td>{{ r.WellPhaseSub || '—' }}</td>
              <td>{{ r.ActualStartDate || '—' }}</td>
              <td>{{ r.ActualEndDate || '—' }}</td>
              <td>{{ r.plannedDuration || '—' }}</td>
              <td>{{ r.TotalDurationHours || '—' }}</td>
              <td [ngClass]="r.durationDeviation < 0 ? 'deviation-favorable' : r.durationDeviation > 0 ? 'deviation-unfavorable' : 'deviation-neutral'" style="font-weight: bold;">
                <span *ngIf="r.durationDeviation !== undefined && r.durationDeviation !== null">
                  {{ r.durationDeviation !== 0 ? (r.durationDeviation < 0 ? '▼' : '▲') : '' }}
                  {{ r.durationDeviation > 0 ? '+' : '' }}{{ r.durationDeviation.toFixed(2) }}
                </span>
                <ng-container *ngIf="r.durationDeviation === undefined || r.durationDeviation === null">—</ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Phase-wise Cost Table -->
  <div class="data-table">
    <div class="table-header">
      <h3 class="table-title">Phase-wise Cost</h3>
      <p class="table-description">Planned AFE Cost | Actual Phase Field Estimate | Variance</p>
    </div>
    <div class="table-scroll">
      <table>
        <thead>
          <tr *ngIf="isMultiWellMode">
            <th>Well Name</th>
            <th>Well Phase</th>
            <th>Sub Phase</th>
            <th>Planned AFE Cost ($K)</th>
            <th>Actual Phase Field Est. ($K)</th>
            <th>Variance ($K)</th>
          </tr>
          <tr *ngIf="!isMultiWellMode">
            <th>Well Phase</th>
            <th>Sub Phase</th>
            <th>Planned AFE Cost ($K)</th>
            <th>Actual Phase Field Est. ($K)</th>
            <th>Variance ($K)</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="isMultiWellMode">
            <tr *ngFor="let w of multiWellPhaseGrouped">
              <td style="font-weight: bold;">{{ w.wellName }}</td>
              <td style="color:#0B2D71;font-weight: 700;">{{ w.primaryJobType }}</td>
              <td>{{ w.subPhase || '—' }}</td>
              <td>{{ w.totalPlannedCost > 0 ? fmtK(w.totalPlannedCost) : '—' }}</td>
              <td>{{ w.totalActualCost > 0 ? fmtK(w.totalActualCost) : '—' }}</td>
              <td [ngClass]="w.totalVariance < 0 ? 'deviation-favorable' : w.totalVariance > 0 ? 'deviation-unfavorable' : 'deviation-neutral'" style="font-weight: bold;">
                {{ w.totalVariance !== 0 ? (w.totalVariance < 0 ? '▼' : '▲') : '' }}
                {{ w.totalVariance > 0 ? '+' : '' }}{{ fmtK(w.totalVariance) }}
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!isMultiWellMode">
            <tr *ngFor="let r of PHASE_WISE">
              <td style="color:#0B2D71;font-weight: bold;">{{ r.WellPhase }}</td>
              <td>{{ r.WellPhaseSub }}</td>
              <td>{{ r.PlannedAFECost > 0 ? fmtK(r.PlannedAFECost) : '—' }}</td>
              <td>{{ r.ActualPhaseFieldEstimate > 0 ? fmtK(r.ActualPhaseFieldEstimate) : '—' }}</td>
              <td [ngClass]="r.variance < 0 ? 'deviation-favorable' : r.variance > 0 ? 'deviation-unfavorable' : 'deviation-neutral'" style="font-weight: bold;">
                <ng-container *ngIf="r.variance !== undefined && r.variance !== null">
                  {{ r.variance !== 0 ? (r.variance < 0 ? '▼' : '▲') : '' }}
                  {{ r.variance > 0 ? '+' : '' }}{{ fmtK(r.variance) }}
                </ng-container>
                <ng-container *ngIf="r.variance === undefined || r.variance === null">—</ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <!-- NPT Cost Impact Bar -->
  <div class="npt-cost-impact">
    <div class="table-header">
      <h3 class="table-title">NPT Cost Impact</h3>
      <p class="table-description">Non-productive time cost as share of total spend</p>
    </div>
    <div class="impact-content">
      <div class="impact-row">
        <span class="impact-label">Total NPT Hours</span>
        <span class="impact-value">
          <ng-container *ngIf="!isMultiWellMode">{{ (+OVERVIEW_NPT_TOTAL_HRS).toFixed(2) }} hrs ({{ OVERVIEW_NPT_PCT }}% of P&amp;A time)</ng-container>
          <ng-container *ngIf="isMultiWellMode">{{ multiWellTotalNptHrs.toFixed(2) }} hrs ({{ (multiWellTotalHrs > 0 ? (multiWellTotalNptHrs / multiWellTotalHrs * 100).toFixed(1) : '0') }}% of P&amp;A time)</ng-container>
        </span>
      </div>
      <div class="impact-row">
        <span class="impact-label">Total NPT Cost</span>
        <span class="impact-value">{{ fmtK(nptCostValue()) }}</span>
      </div>
      <div class="impact-row">
        <span class="impact-label">NPT Cost as % of Actual Spend</span>
        <span class="impact-value">
          {{ nptCostPctValue().toFixed(2) }}%
        </span>
      </div>
      <div class="progress-bar">
        <div class="progress-fill"
          [style.width]="nptCostPctValue().toFixed(2) + '%'">
        </div>
      </div>
    </div>
  </div>
</div>
